import { TriageStatus } from '@/models';
import { GenericService } from '@/services/api/generic.service';

export class TriageStatusService extends GenericService<TriageStatus> {
  endpoint = 'v1/triage-statuses';
}
